import { IonRouterLink } from '@ionic/react';
import { useCallback, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import ExpandableSection from '@components/animations/ExpandableSection';
import PersonalizeForm from '@components/forms/PersonalizeForm';
import Modal from '@components/Modal';
import PMEQuestion from '@components/PMEQuestion';
import styles from '@components/profile/Profile.module.css';
import Icon from '@components/text/Icon';
import Heading2 from '@components/typography/Heading2';
import useOpener from '@hooks/useOpener';
import { CareProfileActionableFieldEnum, GetJourneyWithCareProfileQuery } from '@typing/Generated';
import { PersonalizeExperienceFields } from '@typing/Models';
type Props = {
  journey: GetJourneyWithCareProfileQuery['journey'];
};

const Legal = ({ journey }: Props) => {
  const opener = useOpener();
  const intl = useIntl();

  const [editingQuestion, setEditingQuestion] = useState<PersonalizeExperienceFields[]>([]);

  const personalizeLegalOpener = useOpener();

  const handlePMEQuestionChange = useCallback(
    (field: PersonalizeExperienceFields) => () => {
      setEditingQuestion([field]);
      personalizeLegalOpener.open();
    },
    [personalizeLegalOpener]
  );

  return (
    <div>
      <IonRouterLink onClick={opener.toggle}>
        <div className={styles.section}>
          <Heading2>
            <FormattedMessage id="pages.client.careProfile.sections.legal" />
          </Heading2>
          <Icon
            ariaLabelKey="accessibility.ariaLabels.toggle"
            className={styles.toggleOpener}
            icon={opener.isOpen ? 'chevronUp' : 'chevronDown'}
          />
        </div>
      </IonRouterLink>
      <ExpandableSection isOpen={opener.isOpen}>
        <PMEQuestion
          field={CareProfileActionableFieldEnum.legal_help_needed}
          handleEdit={handlePMEQuestionChange}
          selections={[
            journey.careProfile.legalHelpNeeded === true
              ? intl.formatMessage({ id: 'dictionary.yes' })
              : intl.formatMessage({ id: 'dictionary.no' })
          ]}
        />
      </ExpandableSection>
      <Modal opener={personalizeLegalOpener} title={intl.formatMessage({ id: 'models.careProfile.editCareProfile' })}>
        {() => (
          <PersonalizeForm
            careProfile={journey.careProfile}
            clientRole={null}
            onCancel={personalizeLegalOpener.close}
            onSuccess={personalizeLegalOpener.close}
            questions={editingQuestion}
          />
        )}
      </Modal>
    </div>
  );
};

export default Legal;
